module.exports = __webpack_public_path__ + "static/art3d-bb77b1b2e41fe70397680c057a066a40.jpeg";